function setCookie<T>(name: string, value: T, daysToExpire = 90, path = '/'): void {
  // Ensure the value is a string, or stringify it
  const stringValue = typeof value === 'string' ? value : JSON.stringify(value)

  // Calculate the expiration date
  const expirationDate = new Date()
  expirationDate.setDate(expirationDate.getDate() + daysToExpire)

  // Format the cookie string
  const cookieString = `${name}=${encodeURIComponent(
    stringValue
  )}; expires=${expirationDate.toUTCString()}; path=${path}`

  // Set the cookie
  document.cookie = cookieString
}

function getCookie<T>(name: string): T | null {
  const cookieName = `${name}=`
  const cookies = document.cookie.split(';')

  for (const cookie of cookies) {
    const currentCookie = cookie.trim()
    if (currentCookie.startsWith(cookieName)) {
      // Extract the cookie value
      const cookieValue = decodeURIComponent(currentCookie.substring(cookieName.length))
      return JSON.parse(cookieValue)
    }
  }

  return null
}

export { setCookie, getCookie }
